export class DocumentSliceNode {
  id: string;
  name: string;
  parent: DocumentSliceNode;
  type: string;
  children: Array<DocumentSliceNode>;
  level: number;
  nodeId: string;

  constructor(id: string, name: string, type: string, parent: DocumentSliceNode) {
    this.id = id;
    this.name = name;
    this.parent = parent;
    this.type = type;
    this.level = parent ? parent.level + 1 : 0;
    this.nodeId = this._path('');
    this.children = new Array<DocumentSliceNode>();
  }

  addChild(id: string, name: string, type: string): DocumentSliceNode {
    let child = this.findChild(id, type);
    if (!child) {
      child = new DocumentSliceNode(id, name, type, this);
      this.children.push(child);
    }
    return child;
  }

  findChild(id: string, type: string): DocumentSliceNode {
    return this.children.find((item) => item.id === id && item.type === type);
  }

  ancestors(nodes?: Array<DocumentSliceNode>): Array<DocumentSliceNode> {
    nodes = nodes || new Array<DocumentSliceNode>();
    if (this.parent !== null) {
      nodes.push(this.parent);
      this.parent.ancestors(nodes);
    }
    return nodes;
  }

  _path(value: string): string {
    if (this.parent) value = this.parent._path(value);
    return `${value}_${this.id}`;
  }
}
